import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {FaRegularIcon, FaSolidIcon} from "../../../components/FontAwesomeIcons";
import AppConfig from "../../../config/AppConfig";
import standardEventCover from "../../../img/coriandoli.png";

export class UserPhotoAlbumItem extends React.Component {
    constructor(props) {
        super(props);
        this.coverStyle = {
            minHeight: "160px",
            backgroundSize: "cover",
            backgroundPosition: "center",
            overflow: "hidden",
        };
        this.coverOverlayStyle = {
            minHeight: "160px",
            background: "linear-gradient(180deg, rgba(0,0,0,.08) 0%, rgba(0,0,0,.72) 100%)",
        };
        this.iconBoxStyle = {
            width: "34px",
            minWidth: "34px",
            height: "34px",
        };
    }

    getTitle = _ => {
        const item = this.props.item || {};
        return item.title || item.titolo || item.name || item.nome || "Evento senza titolo";
    }

    getDate = _ => {
        const item = this.props.item || {};
        return item.date || item.data || item.start_date || item.data_inizio || item.event_date;
    }

    getLocation = _ => {
        const item = this.props.item || {};
        return item.location_name || item.location || item.luogo || item.address || item.indirizzo;
    }

    getGuestsCount = _ => {
        const item = this.props.item || {};
        return item.confirmed_count || item.confirmed_reservations_count || item.guests_count || item.invitati_count || item.adesioni_count || item.partecipanti || 0;
    }

    getParticipantsText = _ => {
        const item = this.props.item || {};
        const guestsCount = this.getGuestsCount();
        if (item.expected_participants && parseInt(item.expected_participants, 10) > 0) {
            return `${guestsCount} / ${item.expected_participants} confermati`;
        }
        return `${guestsCount} confermati`;
    }

    getPhotosCount = _ => {
        const item = this.props.item || {};
        return item.photos_count || item.foto_count || item.album_photos_count || 0;
    }

    getEventType = _ => (this.props.item || {}).event_type

    getTypeLabel = _ => this.getEventType() === "photo_album" ? "Album" : "Adesioni"

    getTypeIcon = _ => this.getEventType() === "photo_album" ? "camera" : "user-friends"

    getImageUrl = _ => {
        const imageUrl = (this.props.item || {}).image_url;
        if (!imageUrl) {
            return standardEventCover;
        }
        if (imageUrl.indexOf("http") === 0) {
            return imageUrl;
        }
        return `${AppConfig.webServerUrl}${imageUrl.indexOf("/") === 0 ? imageUrl : `/${imageUrl}`}`;
    }

    getCoverStyle = _ => ({
        ...this.coverStyle,
        backgroundImage: `url(${this.getImageUrl()})`,
    })

    getParsedDate = _ => {
        const date = this.getDate();
        return date ? moment(date) : null;
    }

    hasValidDate = _ => {
        const parsedDate = this.getParsedDate();
        return parsedDate && parsedDate.isValid();
    }

    renderMetaLocation = _ => {
        const location = this.getLocation();
        if (!location) {
            return null;
        }
        return (
            <span className={"ml-2"}>
                <FaSolidIcon name={"map-marker-alt"} className={"mr-1"}/>
                {location}
            </span>
        );
    }

    getPhotoAlbumId = _ => this.props.item.event_album_id || this.props.item.photo_album_id || this.props.item.event_id

    handleEventClick = _ => {
        this.props.onClick(this.getPhotoAlbumId());
    }

    render() {
        return (
            <li className={"list-group-item border-0 p-0 mb-3 bg-transparent"} onClick={this.handleEventClick}>
                <div className={"card border-0 shadow-sm overflow-hidden"}>
                    <div style={this.getCoverStyle()}>
                        <div className={"d-flex flex-column justify-content-between p-3 text-white"} style={this.coverOverlayStyle}>
                            <div>
                                <span className={"badge badge-light text-dark rounded-pill px-3 py-2"}>
                                    <FaSolidIcon name={this.getTypeIcon()} className={"mr-1"}/>
                                    {this.getTypeLabel()}
                                </span>
                            </div>
                            <div>
                                <h5 className={"font-weight-bold mb-1"}>{this.getTitle()}</h5>
                                <div className={"small"}>
                                    {
                                        this.hasValidDate() &&
                                        <span>
                                            <FaRegularIcon name={"calendar"} className={"mr-1"}/>
                                            {this.getParsedDate().format("DD MMM YYYY")}
                                        </span>
                                    }
                                    {this.renderMetaLocation()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"card-body py-3"}>
                        <div className={"d-flex align-items-center"}>
                            <div className={"d-flex align-items-center text-muted small mr-3"}>
                                <div
                                    className={"rounded bg-light d-flex align-items-center justify-content-center text-primary mr-2"}
                                    style={this.iconBoxStyle}
                                >
                                    <FaSolidIcon name={"user-check"}/>
                                </div>
                                <span>{this.getParticipantsText()}</span>
                            </div>
                            <div className={"d-flex align-items-center text-muted small flex-grow-1"}>
                                <div
                                    className={"rounded bg-light d-flex align-items-center justify-content-center text-magenta mr-2"}
                                    style={this.iconBoxStyle}
                                >
                                    <FaRegularIcon name={"images"}/>
                                </div>
                                <span>{this.getPhotosCount()} foto</span>
                            </div>
                            <button type={"button"} className={"btn btn-sm btn-light text-primary font-weight-bold rounded-pill"}>
                                <FaSolidIcon name={"share-alt"} className={"mr-1"}/>
                                Condividi
                            </button>
                        </div>
                    </div>
                </div>
            </li>
        );
    }
}

UserPhotoAlbumItem.propTypes = {
    item: PropTypes.object,
    onClick: PropTypes.func,
};
